// extracted by mini-css-extract-plugin
module.exports =  {"save-seller-btn":"cUju0cA","saveSellerBtn":"cUju0cA"};